import type { Ref } from "react";
import { useRef } from "react";
import type { SectionListProps } from "react-native";
// eslint-disable-next-line no-restricted-imports
import { SectionList as RNSectionList } from "react-native";
import { withUnistyles } from "react-native-unistyles";

import { mergeRefs, ScrollProvider } from "$src/core/contexts/scroll";

const SectionList = (({
  ref: forwardedRef,
  ...props
}: SectionListProps<any, any> & {
  ref?: Ref<RNSectionList<any, any>>;
}) => {
  const ref = useRef<RNSectionList<any, any> | null>(null);

  return (
    <ScrollProvider scrollRef={ref}>
      <RNSectionList {...props} ref={mergeRefs(ref, forwardedRef)} />
    </ScrollProvider>
  );
}) as unknown as typeof RNSectionList;

export default withUnistyles(SectionList) as unknown as typeof RNSectionList;
